import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, ButtonGroup, Form, Pagination } from 'react-bootstrap';
import { FaUsers } from "react-icons/fa";
import './all-employee.css';
import { TbEyeEdit } from "react-icons/tb";
import AtdLayout from '../components/AttendanceLayout'; // Fixed spelling
import { Link } from 'react-router-dom';

// Dummy data for demonstration
const dummyEmployeeData = Array.from({ length: 30 }, (_, index) => ({
  id: index + 1,
  userId: `User${index + 1}`,
  employeeName: `Employee ${index + 1}`,
  department: `Department ${index + 1}`,
  jobTitle: `JobTitle ${index + 1}`,
  role: `Role ${index + 1}`,
  gender: index % 2 === 0 ? 'Male' : 'Female',
  status: index % 2 === 0 ? 'Active' : 'Inactive'
}));

export default function AllEmps() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  
  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(dummyEmployeeData.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(dummyEmployeeData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const displayedData = dummyEmployeeData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  return (
    <AtdLayout> 
      <h1 className="all-emps-title">
        <FaUsers className="settings-icon" /> Employees
      </h1>
      <hr />
      <div className='all-emps-content'>
        <div className='all-emps-actions'>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center mb-2">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                <Dropdown.Menu>
                  <Dropdown.Item as="button">10</Dropdown.Item>
                  <Dropdown.Item as="button">25</Dropdown.Item>
                  <Dropdown.Item as="button">50</Dropdown.Item>
                  <Dropdown.Item as="button">100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
              <div className='search-container'>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="all-emps-search"
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>

        <div className="table-responsive">
          <table className='table table-striped table-style'>
            <thead className="all-emps-table-header">
              <tr className="table-header-footer">
                <th>SR</th>
                <th>UserId</th>
                <th>Employee Name</th>
                <th>Department</th>
                <th>Job Title</th>
                <th>Role</th>
                <th>Gender</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {displayedData.map(item => (
                <tr key={item.id} style={{ textAlign: 'center' }}>
                  <td>{item.id}</td>
                  <td>{item.userId}</td>
                  <td>{item.employeeName}</td>
                  <td>{item.department}</td>
                  <td>{item.jobTitle}</td>
                  <td>{item.role}</td>
                  <td>{item.gender}</td>
                  <td>{item.status}</td>
                  <td>
                    <Link to='/edit-atd'>
                      <Button className='btn btn-primary'><TbEyeEdit /></Button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot className='provident-fund-footer'>
              <tr className="provident-fund-table-footer">
                <td colSpan="9" style={{ textAlign: 'left' }}>
                  Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, dummyEmployeeData.length)} of {dummyEmployeeData.length} entries
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="pagination-container">
          <Row className="custom-row">
            <Col xs={12} md={9} className="custom-col-left">
              Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, dummyEmployeeData.length)} of {dummyEmployeeData.length} entries
            </Col>
            <Col xs={12} md={3} className="custom-col-right">
              <Pagination>
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </Pagination.Prev>
                {pageRange().map(page => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === Math.ceil(dummyEmployeeData.length / rowsPerPage)}
                >
                  Next
                </Pagination.Next>
              </Pagination>
            </Col>
          </Row>
        </div>
      </div>
    </AtdLayout>
  );
}
